import React from 'react';
import { useLocation } from 'react-router-dom';

import ErrorPage from '@app/src/common/components/error-page/ErrorPage';

// `?message=` carries the server's own wording for failures that land here without a permission
// problem — a rejected external-IdP token exchange, for instance. Without it the page would state
// only the generic 403 reason, which in those cases is wrong.
const AccessDenied = () => {
  const { search } = useLocation();
  const detail = new URLSearchParams(search).get('message') || undefined;

  return (
    <ErrorPage errorCode="403" message="error.accessDenied" detail={detail} />
  );
};

export default AccessDenied;
